// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as AuthVm$PorterinFeature from "../../../view-model/AuthVm.mjs";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as AuthInputModuleScss from "../../styles/AuthInput.module.scss";

var defaultStyles = AuthInputModuleScss;

function AuthInputCmp(Props) {
  var label = Props.label;
  var is_required = Props.is_required;
  var is_filled = Props.is_filled;
  var children = Props.children;
  var error = Props.error;
  var stylesOpt = Props.styles;
  var clear_inputOpt = Props.clear_input;
  var show_clear_iconOpt = Props.show_clear_icon;
  var styles = stylesOpt !== undefined ? Caml_option.valFromOption(stylesOpt) : defaultStyles;
  var clear_input = clear_inputOpt !== undefined ? clear_inputOpt : (function (param) {
        
      });
  var show_clear_icon = show_clear_iconOpt !== undefined ? show_clear_iconOpt : false;
  var match = React.useState(function () {
        return false;
      });
  var setFocused = match[1];
  return React.createElement("div", {
              className: styles.container,
              onFocus: (function (param) {
                  Curry._1(setFocused, (function (param) {
                          return true;
                        }));
                }),
              onBlur: (function (param) {
                  Curry._1(setFocused, (function (param) {
                          return false;
                        }));
                })
            }, React.createElement("div", {
                  className: Belt_Option.isSome(error) ? "" + styles["input-container"] + " " + styles["input-container-error"] + "" : (
                      match[0] ? "" + styles["input-container-focus"] + " " + styles["input-container"] + "" : styles["input-container"]
                    )
                }, React.createElement("label", {
                      className: "" + (
                        is_required ? styles["label-required"] : styles.label
                      ) + " \n            " + (
                        Belt_Option.isSome(error) ? styles.error : ""
                      ) + " \n            " + (
                        is_filled ? "" : styles.filled
                      ) + "\n            ",
                      htmlFor: label
                    }, label), children, show_clear_icon ? (
                    is_filled ? null : React.createElement("div", {
                            className: styles["error-icon"],
                            onClick: clear_input
                          }, React.createElement(NextImage$PorterinFeature.make, {
                                src: AuthVm$PorterinFeature.clear_input_icon.src,
                                height: AuthVm$PorterinFeature.clear_input_icon.height,
                                width: AuthVm$PorterinFeature.clear_input_icon.width,
                                quality: 70.0,
                                alt: AuthVm$PorterinFeature.clear_input_icon.alt
                              }))
                  ) : (
                    Belt_Option.isSome(error) ? React.createElement("div", {
                            className: styles["error-icon"]
                          }, React.createElement(NextImage$PorterinFeature.make, {
                                src: AuthVm$PorterinFeature.input_error.src,
                                height: AuthVm$PorterinFeature.input_error.height,
                                width: AuthVm$PorterinFeature.input_error.width,
                                quality: 70.0,
                                alt: AuthVm$PorterinFeature.input_error.alt
                              })) : null
                  )), error !== undefined ? React.createElement("div", {
                    className: styles["error-container"]
                  }, error) : null);
}

var make = AuthInputCmp;

export {
  defaultStyles ,
  make ,
}
/* defaultStyles Not a pure module */
